import type {Editor} from 'grapesjs';
import type {BlockCategoryMap} from '@Components/email-maker-block-manager/email-maker-block-manager.types';

export enum ElementsSubPanel {
  ELEMENTS = 'elements',
  TEXT = 'text',
  IMAGE = 'image',
}

export interface ElementBlockPanelProps {
  blocksMap: BlockCategoryMap;
  showBackButton?: boolean;
  headerLabel?: string;
  onBackButton?: VoidFunction;
  gjsEditor: Editor;
  /** Controlled sub-panel state. When set (with `onSubPanelChange`), the host owns the header — the sub-panels render headerless. */
  subPanel?: ElementsSubPanel;
  onSubPanelChange?: (subPanel: ElementsSubPanel) => void;
}
